import {FC} from 'react'
import { useHistory } from 'react-router-dom'

const socials = [
  {icon: '/media/svg/nobilis/instagram.svg'},
  {icon: '/media/svg/nobilis/fb_01.svg'},
  {icon: '/media/svg/nobilis/x_01.svg'},
]

interface Props {
  memberId?: number
  // PR-I-85: se restaura Book Expertise, pero condicionado. Ver comentario abajo.
  hasExpertise?: boolean
  partnerStatus?: 'active' | 'pending' | 'inactive' | 'suspended' | null
  // PR-I-85: Partner.id — la ruta /experts/<id>/book hace lookup por Partner.id, no User.id.
  partnerId?: number | null
}

export const MemberActions: FC<Props> = ({memberId, hasExpertise = false, partnerStatus = null, partnerId = null}) => {
  const history = useHistory()

  const handleRequestIntroduction = () => {
    if (!memberId) return
    history.push(`/introduction/request/${memberId}`)
  }

  // PR-I-85: se re-agrega "Book Expertise" en la ficha publica del member (revierte parte de
  // PR-I-80). Solo visible cuando el member tiene expertise registrada Y el bridge de PR-I-86
  // ya creo un Partner con status='active' (staff aprobo) Y el back nos dio el partnerId. Sin
  // esos dos datos el boton no navegaria a nada util: /experts/<id>/book hace lookup por
  // Partner.id (no User.id) y sin el id explicito el endpoint responde 404.
  const canBookExpertise = hasExpertise && partnerStatus === 'active' && partnerId != null

  const handleBookExpertise = () => {
    if (partnerId == null) return
    history.push(`/experts/${partnerId}/book`)
  }

  return (
    <div className='member-detail__actions'>
      <div className='member-detail__buttons'>
        <div className='member-detail__btn member-detail__btn--primary' onClick={handleRequestIntroduction}>
          <div className='member-detail__btn-text'>request introduction</div>
          <svg
            width='14'
            height='4'
            viewBox='0 0 14 4'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path d='M8.5 0.379883L12 3.38403H0' stroke='white' />
          </svg>
        </div>
        {canBookExpertise && (
          <div className='member-detail__btn member-detail__btn--primary' onClick={handleBookExpertise}>
            <div className='member-detail__btn-text'>book expertise</div>
            <svg
              width='14'
              height='4'
              viewBox='0 0 14 4'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'
            >
              <path d='M8.5 0.379883L12 3.38403H0' stroke='white' />
            </svg>
          </div>
        )}
      </div>
    </div>
  )
}
